export default "__VITE_ASSET__b915c65b__"